import apiInstance from "./axios";
import { user, profile } from "utils/services/api/schemas";
import liff from "@line/liff";


const userApi = {
  registerUser: async (payload) => {
    const idToken = liff.getIDToken();
    const formData = new FormData();
    for (const key in payload) {
      formData.append(key, payload[key]);
    }
    const response = await apiInstance.post(user, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${idToken}`,
      },
    });
    return response;
  },
  updateProfile: async (payload) => {
    const response = await apiInstance.put(`${user}/update`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  },
  getProfile: async () => {
    const response = await apiInstance.get(profile);
    return response;
  },
};

export default userApi;
